import * as fetcher from '@hydra/utils/fetcher';

export async function createProject (url, subFolder) {
  try {
    return await fetcher.post('/api/projects', { json: { url, subFolder } }).json();
  } catch (err) {
    if (err instanceof fetcher.HTTPError) {
      const { error, ...props } = await err.response.json();
      throw Object.assign(new Error(error), props);
    }
    throw err;
  }
}

export async function deleteProject (url) {
  await fetcher.del('/api/projects', { json: { url } });
}

export async function getProject (url) {
  return fetcher.get('/api/project', { searchParams: { url } }).json();
}
